import React, { Component } from 'react';
import Autoload from '../../../../neoverv/Autoload';
import { connect } from 'react-redux';
import { hideNotification, showNotification } from '@mantine/notifications';
import RightArrowIcon from '../../../../assets/images/module/general/RightArrowIcon.svg';
import GrayTick from '../../../../assets/images/module/general/GrayTick.svg';
import SelectArrowDown from '../../../../assets/images/module/general/SelectArrowDown.svg';
import UtilityBillingAssignedIcon from '../../../../neoverv/components/SVGs/utilityBillingAssigned';
import SelectArrowUp from '../../../../assets/images/module/general/SelectArrowUp.svg';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import RedTick from '../../../../assets/images/module/general/RedTick.svg';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import MinimizeIcon from '@material-ui/icons/Minimize';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
//import Papa from 'papaparse';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Stack, Group, Select, Accordion, Loader, SimpleGrid, Tooltip } from '@mantine/core';
import { Col, Form, Row } from 'react-bootstrap';
import { ColorButton, DeleteModal, SwitchContainer } from '../../../../neoverv';
import TemperatureNotificationModal from '../../../../neoverv/components/Module/General/CustomModal/TemperatureNotificationModal';
import TilesForTenantPortal from './TilesForTenantPortal';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import CloseButtonIcon from '../../../../assets/images/module/general/CloseButtonIcon.svg';
import {arrayMove, SortableContainer, SortableElement, sortableHandle} from 'react-sortable-hoc';
import {arrayMoveImmutable} from 'array-move';
import VisibilityIcon from '@material-ui/icons/Visibility';
import TenantPortalTilePreviewModal from '../../../../neoverv/components/Module/General/CustomModal/TenantPortalTilePreviewModal';
import TileDetailsModal from '../../../../neoverv/components/Module/General/CustomModal/TileDetailsModal';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const pStyle= {
    fontFamily: 'Inter, sans-serif',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
    color: 'rgb(14, 14, 29)'
}
const tableStyle= {
    border: 'none',
    padding: '5px 0px',
    textAlign: 'center'
}
const tableHeaderStyle= {
    // fontWeight: '500', 
    // lineHeight: '16px',
    // fontFamily: 'Inter, sans-serif',
    // whiteSpace: 'nowrap',
    // width: '200px',
    // maxWidth: '200px',
    // textAlign: 'left'
    whiteSpace: 'nowrap',
    border: 'none',
    paddingBottom: '0px',
    fontSize: '12px',
    fontWeight: '400',
    color:'#727293',
    width: '80px',
    width: '200px',
    maxWidth: '200px',
    textAlign: 'left'
}

const DragHandle = sortableHandle(() => 
<DragIndicatorIcon
style={{
    width: '16px', 
    color: '#727293', 
    cursor: 'grab',
    marginTop: '4px'
}}
/>);

const SortableItem = SortableElement(({tile, handleSort, dragTileOver, dragTile, index, setState, dragStart, loader, deleteTile, updateTitle, updateHtml, updateIsActive, update}) => 
<Group
//draggable
// onDragStart={() => {
//     dragTile.current = index;
//     setState({dragStart: true});
// }}
//onDragEnter={() => (dragTileOver.current = index)}
//onDragEnd={handleSort}
//onDragOver={(e) => e.preventDefault()}
style={{
    background: '#F7F7FA',
    boxShadow: '0 1px 3px rgba(0,0,0,.08)',
    borderRadius: '4px',
    width: '100%',
    padding: '20px',
    height: (dragStart || loader) ? '150px' : '500px', // loader.find((tileId)=> tileId === tile.id) !== undefined
    //transition: 'height 0.02s',
}}
>
    <Group wrap="nowrap" style={{width: '100%'}}>
        <DragHandle/>
        {!loader && !dragStart &&
        <Group justify="space-between" style={{width: '100%'}}>
            <Group>
                <SwitchContainer
                checked={tile.isActive}
                switchText={'aktivieren'}
                disabled={false}
                onChange={()=> updateIsActive(tile.id, !tile.isActive)}
                />
            </Group>
            <Group 
            onClick={()=> {
                console.log('deleteTile: ', tile.id);
                deleteTile(tile.id);
            }}>
                <img src={CloseButtonIcon} style={{cursor: 'pointer', padding: '0px 10px', marginTop: '4px'}}/>
            </Group>
        </Group>}                                        
    </Group>
    
    <TilesForTenantPortal
    body={tile.body}
    id={tile.id}
    title={tile.title}
    displayOrder={tile.displayOrder}
    loader={loader}
    dragStart={dragStart}
    index={index}
    updateTitle={(title, onBlur=false)=> {
        updateTitle(tile.id, title);
        if(onBlur){
            update(tile.id);
        }
    }}
    updateHtml={(body, onBlur=false)=> {
        updateHtml(tile.id, body);
        if(onBlur){
            update(tile.id);
        }
    }}
    deleteTile={()=> {
        console.log('deleteTile: ', tile.id);
        deleteTile(tile.id)
    }}
    />
</Group>);

const SortableList = SortableContainer(({items, handleSort, dragTileOver, dragTile, setState, dragStart, loader, deleteTile, updateTitle, updateHtml, updateIsActive, update}) => {
  return (items.sort((a, b)=> a.displayOrder - b.displayOrder)
    .map((tile, index) => (
        <SortableItem 
        key={`item-${tile.id}`} 
        index={index} 
        tile={tile} 
        // handleSort={handleSort} 
        // dragTileOver={dragTileOver} 
        // setState={setState} 
        // dragStart={dragStart} 
        update={(id)=> update(id)}
        loader={loader} 
        deleteTile={(tileId)=> deleteTile(tileId)} 
        updateTitle={(tileId, title)=> updateTitle(tileId, title)} 
        updateHtml={(tileId, body)=> updateHtml(tileId, body)}
        updateIsActive={(tileId, isActiveStatus)=> updateIsActive(tileId, isActiveStatus)}
        />
    ))
  );
});

export class TenantAdministrateTilesSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            minimize: true,
            tiles: [
                // {
                //     body: '<p>test 1</p>',
                //     id: 0,
                //     title: 'title 1',
                //     propertyId: '0000',
                //     displayOrder: 1,
                //     isActive: false,

                // },
                // {
                //     body: '<p>test 2</p>',
                //     id: 1,
                //     title: 'title 2',
                //     propertyId: '0000',
                //     displayOrder: 2,
                //     isActive: false,

                // },
                // {
                //     body: '<p>test 3</p>',
                //     id: 2,
                //     title: 'title 3',
                //     propertyId: '0000',
                //     displayOrder: 3,
                //     isActive: false,

                // }//,
                // {
                //     id: 'add',
                //     body: null,
                //     displayOrder: 4,
                //     title: 'Add',
                // }
                // {
                //     body: null,
                //     id: 1,
                //     title: null,
                // },
                // {
                //     body: null,
                //     id: 2,
                //     title: null,
                // }
            ],
            loader: false,//[]
            dragStart: false,
            mainLoader: false,
            openTenantPortalTilePreviewModal: false,
            openTileDetailModal: false,
            tileDataForPreview: null,
            individualLoader: null,
            openDeleteModal: false,
            deleteTileId: null,
            propertyData: null,
            allImagesData: []
        };
        this.dragTile = React.createRef();
        this.dragTileOver = React.createRef();
    }

    componentDidMount(){
        this.getPropertyNotes();
        this.setState({propertyData: this.props.propertyData});
    }

    componentDidUpdate(prevProps){
        if(prevProps.propertyData !== this.props.propertyData){
            this.setState({propertyData: this.props.propertyData});
        }
    }

    addTile=()=>{
        let {tiles} = this.state;
        this.postPropertyNotes({
            body: '<p></p>',
            title: null,
            displayOrder: tiles.length > 0 ? (tiles[tiles.length - 1].displayOrder + 1) : 1,
            isActive: true,
        });
        // tiles.pop();
        // tiles.push({
        //     body: `<p>test body ${tiles.length > 0 ? (tiles[tiles.length - 1].displayOrder + 1) : 1}</p>`,
        //     id: tiles.length,
        //     title: `Test title ${tiles.length > 0 ? (tiles[tiles.length - 1].displayOrder + 1) : 1}`,
        //     propertyId: '0000',
        //     displayOrder: tiles.length > 0 ? (tiles[tiles.length - 1].displayOrder + 1) : 1,
        //     isActive: true,
        // });
        

        // tiles.push({
        //     id: 'add',
        //     body: null,
        //     //displayOrder: tiles.length > 0 ? (tiles[tiles.length - 1].displayOrder + 1) : 1,
        //     title: 'Add',
        // });
        //this.setState({tiles});
    }

    randomRecep=()=>{
        return Math.floor((Math.random() * 3));
       }
       
    assignTemp=(tempArr)=>{
        const number = this.randomRecep();
        if (tempArr.includes( number ) ) {
        console.warn( `${number} exists in [${tempArr.join(', ')}]` );
        return this.assignTemp(tempArr);
        }
        console.warn( `adding ${number} to [${tempArr.join(', ')}]` );
        tempArr.push( number );
        return tempArr;
    }

    updateTile=(id, tileField, value, onBlur=false)=>{
        console.log('updateTile', id);
        if(id){
            let {tiles} = this.state;
            tiles = tiles.map((tile)=> {
                if(tile?.id === id){
                    tile[tileField] = value;
                    return tile;
                }else{
                    return tile;
                }
            });
            this.setState({tiles}, ()=> {
                if(onBlur){
                    this.putPropertyNotes(id);
                }
            });
        }
    }

    // updateTitle=(id, title, onBlur=false)=>{
    //     let {tiles} = this.state;
    //     tiles = tiles.map((tile)=> {
    //         if(tile.id === id){
    //             tile.title = title;
    //             return tile;
    //         }else{
    //             return tile;
    //         }
    //     });
    //     this.setState({tiles}, ()=> {
    //         if(onBlur){
    //             this.putPropertyNotes(id);
    //         }
    //     });
    // }

    // updateHtml=(id, body, onBlur=false)=>{
    //     let {tiles} = this.state;
    //     tiles = tiles.map((tile)=> {
    //         if(tile.id === id){
    //             tile.body = body;
    //             return tile;
    //         }else{
    //             return tile;
    //         }
    //     });
    //     this.setState({tiles}, ()=> {
    //         if(onBlur){
    //             this.putPropertyNotes(id);
    //         }
    //     });
    // }

    // updateIsActive=(id, isActive)=>{
    //     let {tiles} = this.state;
    //     tiles = tiles.map((tile)=> {
    //         if(tile.id === id){
    //             tile.isActive = isActive;
    //             return tile;
    //         }else{
    //             return tile;
    //         }
    //     });
    //     this.setState({tiles}, ()=> this.putPropertyNotes(id));
    // }

    deleteTile=(id)=>{
        console.log('deleteTile: ', id);
        let {tiles} = this.state;
        tiles = tiles.filter((tile)=> tile.id !== id);
        this.setState({tiles}, ()=> this.deletePropertyNotes(id));
    }

    handleSort=()=> {
        console.log('handleSort');
        let {tiles} = this.state;
        this.setState({loader: true,//[tiles[this.dragTile.current].id, tiles[this.dragTileOver.current].id], 
            dragStart: false},()=>{
            const temp = tiles[this.dragTile.current];
            tiles[this.dragTile.current] = tiles[this.dragTileOver.current];
            tiles[this.dragTileOver.current] = temp;
            
            this.setState({tiles}, ()=> 
            setTimeout(() => {
                tiles = tiles.map((tile, index)=> {
                    tile.displayOrder = (index+1)
                    return tile;
                });
                this.setState({loader: false, tiles}, ()=> setTimeout(() => {
                    this.updateAllNotes();
                }, 1000));
            }, 500));
        });
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        console.log('onSortEnd: ', oldIndex, newIndex);
        this.setState(({tiles}) => ({
            tiles: arrayMoveImmutable(tiles, oldIndex, newIndex),
        }));
    };

    updateAllNotes=()=>{
        console.log('updateAllNotes');
        //let {tiles} = this.state;
        const {tiles} = this.state;
        tiles.map((tile)=> this.putPropertyNotes(tile.id));
        // this.setState({
        //     tiles: tiles.map((tile, index)=> ({...tile, displayOrder: (index+1)}))
        // }, ()=> tiles.map((tile)=> this.putPropertyNotes(tile.id)));
    }

    getPropertyNotes=(loader=true)=>{
        this.setState({mainLoader: loader});
        let propertyId = this.props.propertySelected && this.props.propertySelected.id;
        Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.property_api_base_url + 'notes?propertyId=' + propertyId,
        'GET',
        null,
        null,
        false,
        true,
        false,
        this,
        'handleGetPropertyNotes',
        null,
        false,
        '',
        {
            // 'Content-Type': 'application/json',
            Authorization: Autoload.Utils.getAuthToken(),
        },
        true
        );
    }

    async handleGetPropertyNotes(response){
        const setTiles=(values)=> this.setState({tiles: values.sort((a, b)=> a.displayOrder - b.displayOrder)});
        if(response.status && response.statuscode === 200){
            if(response.result.find((tile)=> tile.body.includes('<img')) !== undefined){
                // let tiles= response.result.map((tile)=> {
                //     let parser = new DOMParser();
                //     let doc = parser.parseFromString(tile.body, 'text/html');
    
                //     doc.querySelectorAll('img').forEach((img, index) => {
                //         let src = this.getDocumentPromise(img.id);
                //         src.then((value)=> {
                //             console.log('src: ', value);
                //             img.src = value;

                //             if(doc.querySelectorAll('img').length === (index + 1)){
                //                 let modifiedHtmlString = doc.body.innerHTML;
                //                 console.log('src: ', modifiedHtmlString);
                //                 tile.body = modifiedHtmlString;
                //             }
                //         });
                //     });

                //     return tile;
                // });

                let tiles = await Promise.all(
                    response.result.map(async (tile) => {
                      let parser = new DOMParser();
                      let doc = parser.parseFromString(tile.body, 'text/html');
                  
                      // Collect all promises for image sources
                      const imgPromises = Array.from(doc.querySelectorAll('img')).map(async (img, index) => {
                        const src = await this.getDocumentPromise(img.id);
                        img.src = src;
                      });
                  
                      // Wait for all image sources to be resolved before proceeding
                      await Promise.all(imgPromises);
                  
                      // After all images are processed, update the tile body with the modified HTML
                      tile.body = doc.body.innerHTML;
                      return tile;
                    })
                );
                setTimeout(() => {
                    setTiles(tiles);    
                }, 1000);
            }else{
                setTimeout(() => {
                    setTiles(response.result);    
                }, 1000);
            }
        }

        setTimeout(() => {
            this.setState({mainLoader: false});    
        }, 600);
    }

    getDocumentPromise=(id)=> 
    new Promise((resolve, reject) => {
        fetch(Autoload.Setting.document_api_base_url + 'documents/' + id,
        {
        method: 'GET',
        headers: {
            'Authorization': Autoload.Utils.getAuthToken()
        }
        })
        .then(data2 => {
        data2.json()
        .then(response2 => {
            let {allImagesData} = this.state;
            allImagesData.push({
                id: response2?.result?.id,
                fileLocation: response2?.result?.fileLocation
            });
            this.setState({
                allImagesData,
                noSaveDuringImageUpload: false
            }, ()=> resolve(response2?.result?.fileLocation));
        })}).catch(()=> reject(new Error('Download failed')));
    })

    postPropertyNotes=(newNote)=>{
        this.setState({mainLoader: true});
        let propertyId = this.props.propertySelected && this.props.propertySelected.id;
        let payload = {
            ...newNote,
            propertyId
        }
        Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.property_api_base_url + 'notes',
        'POST',
        payload,
        null,
        false,
        true,
        false,
        this,
        'handlePostPropertyNotes',
        null,
        false,
        '',
        {
            // 'Content-Type': 'application/json',
            Authorization: Autoload.Utils.getAuthToken(),
        },
        true
        );
    }

    handlePostPropertyNotes(response){
        if(response.status && response.statuscode === 200){
            showNotification({
                message: 'Neuer Aushang erstellt.',
                icon: <img src={GreenTick} alt='green-tick'/>,
                id: 'addTile'
            });
            // this.getPropertyNotes();
            let {tiles} = this.state;
            tiles.push(response.result);
            this.setState({tiles, mainLoader: false});
        }else{
            showNotification({
                message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
                icon: <img src={RedCross} alt='red-cross'/>,
                id: 'tileGeneralError'
            });
        }
    }

    putPropertyNotes=(id)=>{
      this.setState({individualLoader: id});
      const {tiles} = this.state;
      
      // 1. Find the target tile
      const targetTile = tiles.find((tile)=> tile.id === id);
      if (!targetTile) {
          this.setState({individualLoader: null});
          return;
      }

      // 2. Clone the payload so we DO NOT mutate React state directly!
      let payload = { ...targetTile };
      
      const oldPayloadBody = payload.body;
      let parser = new DOMParser();
      let doc = parser.parseFromString(oldPayloadBody, 'text/html');
      
      let allImgIds= [];
      doc.querySelectorAll('img').forEach((img, index) => {
          // Strip src for the backend payload
          if(img.src && img.src.length > 0){
              img.removeAttribute('src');
          }

          if(img.id && img.id.length > 0){
              allImgIds.push(img.id);
          }else{
              allImgIds.push(null);
          }
      });

      // 3. Apply the stripped HTML ONLY to our cloned payload
      payload.body = doc.body.innerHTML;

      if(allImgIds.find((id)=> id === null) === undefined){
          Autoload.HttpRequestAxios.HttpRequest(
              Autoload.Setting.property_api_base_url + 'notes/' + payload.id,
              'PUT',
              payload, // Send the clone safely to the API
              null,
              false,
              true,
              false,
              this,
              'handlePutPropertyNotes',
              {oldPayloadBody},
              false,
              '',
              {
                  // 'Content-Type': 'application/json',
                  Authorization: Autoload.Utils.getAuthToken(),
              },
              true
          );
      }else{
          this.setState({individualLoader: null});
      }
  }

    handlePutPropertyNotes(response){
        if(response.status && response.statuscode === 200){
            showNotification({
                message: 'Änderungen übernommen.',
                icon: <img src={GreenTick} alt='green-tick'/>,
                id: 'updateTile'
            });
            //this.getPropertyNotes(false);
            let {tiles} = this.state;
            tiles = tiles.map((tile)=> {
                if(tile.id === response.result.id){
                    tile.body= response.other.oldPayloadBody;
                }
                return tile;
            });
            this.setState({tiles});
        }else if(response.status === false && response.result.length > 0 && response.result.find((error)=> error.errorField === 'Body') !== undefined){
            showNotification({
                message: 'Die eingegebenen Informationen haben die zulässige Gesamtlänge des Beitrags überschritten.',
                icon: <img src={RedCross} alt='red-cross'/>,
                id: 'tileBodyLimitExceedError'
            });
        }else{
            showNotification({
                message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
                icon: <img src={RedCross} alt='red-cross'/>,
                id: 'tileGeneralError'
            });
        }

        this.setState({individualLoader: null});
    }

    deletePropertyNotes=(noteId)=>{
        this.setState({mainLoader: true});
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.property_api_base_url + 'notes/' + noteId,
            'DELETE',
            null,
            null,
            false,
            true,
            false,
            this,
            'handleDeletePropertyNotes',
            {noteId},
            false,
            '',
            {
                // 'Content-Type': 'application/json',
                Authorization: Autoload.Utils.getAuthToken(),
            },
            true
        );
    }

    handleDeletePropertyNotes(response){
        if(response.status && response.statuscode === 200){
            showNotification({
                message: 'Aushang wurde gelöscht.',
                icon: <img src={RedTick} alt='red-tick'/>,
                id: 'tileDelete'
            });
            //this.getPropertyNotes();
            let {tiles} = this.state;
            tiles = tiles.filter((tile)=> tile.id !== response.other.noteId);
            this.setState({tiles});
        }else{
            showNotification({
                message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
                icon: <img src={RedCross} alt='red-cross'/>,
                id: 'tileGeneralError'
            });
        }

        this.setState({openDeleteModal: false, mainLoader: false});
    }

    putPropertyData =(isNotesSectionHidden=null)=>{
        hideNotification('save_property_data');
        let payload = this.state.propertyData;
        payload.isNotesSectionHidden = isNotesSectionHidden !== null ? isNotesSectionHidden : payload.isNotesSectionHidden;
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.property_api_base_url + 'properties/' + this.props.propertySelected.id,
            'PUT',
            payload,
            null,
            false,
            true,
            false,
            this,
            'handle_put_property_data',
            null,
            false,
            '',
            {
              'Content-Type': 'application/json',
              Authorization: Autoload.Utils.getAuthToken(),
            }
          );
    }

    handle_put_property_data(response){
        if(response.status){
            showNotification({
                id: 'save_property_data',
                message: 'Änderung übernommen',
                icon: <img src={GreenTick} alt='green-tick'/>,
            });
            this.props.getPropertyData();
        }
    }

    handleDragEnd = (result) => {
        const {tiles} = this.state;
        if (!result.destination) return;
    
        const items = Array.from(tiles);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
    
        // Update displayOrder based on new positions
        const updatedTiles = items.map((tile, index) => ({
          ...tile,
          displayOrder: index + 1, // Update displayOrder to reflect the new order
        }));
    
        this.setState({tiles: updatedTiles, dragStart: false}, ()=> this.updateAllNotes());
        // You can save updatedNotes to your backend or perform further operations here
    };

    handleDragStart = () => {
        this.setState({dragStart: true});
    };

    renderPreviewAndSwitch=(tile)=>{
        const {isMobile} = this.props;
        return (
            <Group align={'center'} wrap="nowrap">
                <SwitchContainer
                checked={tile?.isActive}
                switchText={<span style={{whiteSpace: 'nowrap'}}>Aushang anzeigen</span>}
                disabled={false}
                onChange={()=> this.updateTile(tile?.id, 'isActive', !tile?.isActive, true)}
                />
            </Group>
        )
    }
  
    render() {
        const {isMobile} = this.props;
        const {minimize, tiles, loader, dragStart, mainLoader, openTenantPortalTilePreviewModal, openTileDetailModal, tileDataForPreview, individualLoader, openDeleteModal, deleteTileId, propertyData, allImagesData} = this.state;
        console.log('tiles: ', tiles);
        console.log('propertyData: ', propertyData);

        console.log('allImagesData: ', allImagesData);

        console.log('tileDataForPreview: ', tileDataForPreview);
        return (
            <div 
            style={{
            width: '100%',
            background: 'white',
            boxShadow: '0 1px 3px rgba(0,0,0,.08)',
            borderRadius: '4px'
            }}>
                <Accordion
            classNames={{
                label: 'tenant-administration-accordion-label',
                panel: 'tenant-administration-accordion-inner-content', // V7 FIX: 'contentInner' is now 'panel'
                control: 'tenant-administration-accordion-control',
                icon: 'tenant-administration-accordion-icon',
            }}
            // V7 FIX: Tie the Accordion open/close state directly to your existing `minimize` state
            value={minimize ? null : 'tiles'}
            onChange={(value) => this.setState({ minimize: value === null })}
            styles={{ chevron: { display: 'none' } }} // V7 FIX: Hides default chevron
            iconPosition='right'
            >
                <Accordion.Item value="tiles" style={{ border: 'none' }}>
                    
                    {/* V7 FIX: Clickable headers must be wrapped in Accordion.Control */}
                    <Accordion.Control p={0}>
                        <Group
                        justify='space-between'
                        style={{
                            padding: '12.1px 24px',
                            borderBottom: !propertyData?.isNotesSectionHidden && minimize === false ? '1px solid #dadae6' : 'none',
                            borderTopLeftRadius: '4px',
                            borderTopRightRadius: '4px',
                            borderBottomLeftRadius: minimize && '4px',
                            borderBottomRightRadius: minimize && '4px',
                            background: 'white',
                            cursor: 'pointer'
                        }}
                        wrap="nowrap">
                            <Group wrap="nowrap" className='tenant-administration-tiles-section'>
                                <h5 
                                style={{
                                    fontWeight: '500',
                                    fontSize: '16px',
                                    lineHeight: '24px',
                                    color: '#0e0e1d',
                                    marginBottom: '0px'
                                }}
                                className={'tenant-administration-display-messages-heading tooltips'}>
                                    Aushänge
                                </h5>
                                
                                {/* V7 FIX: Prevent clicking the switch from also toggling the Accordion */}
                                <div onClick={(e) => e.stopPropagation()}>
                                    <SwitchContainer
                                    checked={!propertyData?.isNotesSectionHidden}
                                    switchText={'aktivieren'}
                                    disabled={false}
                                    onChange={()=> this.putPropertyData(!propertyData?.isNotesSectionHidden)}
                                    />
                                </div>
                            </Group>
                            {!propertyData?.isNotesSectionHidden && (!minimize ? <ExpandMoreIcon style={{color: '#13135C'}} /> : <NavigateNextIcon style={{color: '#13135C'}} />)}
                        </Group>
                    </Accordion.Control>

                    {/* V7 FIX: Content must be wrapped in Accordion.Panel */}
                    <Accordion.Panel 
                        style={{
                            // Replaces your old v4 styles object for 'content'
                            display: propertyData?.isNotesSectionHidden ? 'none' : 'block',
                            boxShadow: propertyData?.isNotesSectionHidden ? 'none' : undefined,
                        }}
                    >
                        <div style={{padding: '12.1px 24px 30px'}}>
                            <Stack justify={'center'} align='center'>
                                {mainLoader ?
                                <Group justify='center' align='center' style={{height: '500px'}}>
                                    <Loader/>
                                </Group>
                                :
                                <Group style={{width: '100%'}} className='drag-container-notes' justify='left'>
                                    <DragDropContext onDragEnd={this.handleDragEnd} onDragStart={this.handleDragStart}>
                                        <Droppable droppableId="notesGrid">
                                            {(provided) => (
                                            <div
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}
                                            >
                                                <SimpleGrid cols={isMobile ? 1 : 2} style={{width: '100%'}}>
                                                    {tiles.length > 0 && tiles.map((tile, index) => (
                                                    <Draggable key={tile.id} draggableId={tile.id} index={index}>
                                                        {(provided) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            style={{
                                                            ...provided.draggableProps.style,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            width: dragStart ? '500px' : '100%',
                                                            }}
                                                        >
                                                            <Stack
                                                            style={{
                                                                background: '#F7F7FA',
                                                                boxShadow: '0 1px 3px rgba(0,0,0,.08)',
                                                                borderRadius: '4px',
                                                                width: '100%',
                                                                padding: '20px',
                                                                height: isMobile ? 'auto' : (dragStart || loader) ? '150px' : '500px',
                                                            }}
                                                            >
                                                                <Group wrap="nowrap" style={{width: '100%'}} justify={isMobile && 'space-between'}>
                                                                    {/* Drag Indicator Icon */}
                                                                    <div
                                                                    {...provided.dragHandleProps} // Apply dragHandleProps only to the icon
                                                                    style={{
                                                                        cursor: dragStart ? 'grabbing' : 'grab',
                                                                        marginTop: '4px',
                                                                        alignSelf: 'flex-start',
                                                                    }}
                                                                    >
                                                                        <Tooltip label={'Reihenfolge verschieben'}>
                                                                            <DragIndicatorIcon
                                                                            style={{
                                                                                width: '16px', 
                                                                                color: '#727293'
                                                                            }}
                                                                            />
                                                                        </Tooltip>
                                                                    </div>
                                                                    <Tooltip label={'Vorschau des Aushangs anzeigen'}>
                                                                        <VisibilityIcon
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            //color: '#5555FF',
                                                                            fontSize: '16px',
                                                                            opacity: 0.4,
                                                                            marginTop: '4px'
                                                                        }} 
                                                                        onClick={()=> this.setState({openTenantPortalTilePreviewModal: true, tileDataForPreview: tile})}
                                                                        />
                                                                    </Tooltip>
                                                                    {!loader && !dragStart && //loader.find((tileId)=> tileId === tile.id) === undefined
                                                                    <Group justify={isMobile ? 'right' : 'space-between'} style={{width: '100%'}} wrap="nowrap">
                                                                        {!isMobile && this.renderPreviewAndSwitch(tile)}
                                                                        <Group>
                                                                            {individualLoader === tile?.id ?
                                                                            <Loader size={'xs'}/>
                                                                            :
                                                                            <img src={CloseButtonIcon} style={{cursor: 'pointer', padding: '0px 10px', marginTop: '4px'}} onClick={()=> this.setState({openDeleteModal: true, deleteTileId: tile.id})}/>}
                                                                        </Group>
                                                                    </Group>}                                        
                                                                </Group>
                                                                {isMobile && this.renderPreviewAndSwitch(tile)}
                                                                <TilesForTenantPortal
                                                                body={tile?.body}
                                                                id={tile?.id}
                                                                title={tile?.title}
                                                                displayOrder={tile?.displayOrder}
                                                                loader={loader}
                                                                dragStart={dragStart}
                                                                index={index}
                                                                allImagesData={allImagesData}
                                                                isMobile={isMobile}
                                                                updateTitle={(title, onBlur=false)=> this.updateTile(tile?.id, 'title', title, onBlur)}
                                                                updateHtml={(body, onBlur=false)=> this.updateTile(tile?.id, 'body', body, onBlur)}
                                                                />
                                                            </Stack>
                                                        </div>
                                                        )}
                                                    </Draggable>
                                                    ))}
                                                    {!dragStart &&
                                                    <Group 
                                                    style={{
                                                        background: '#F7F7FA', 
                                                        padding: '40px',
                                                        boxShadow: '0 1px 3px rgba(0,0,0,.08)',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        height: (dragStart || loader) ? '150px' : '500px',
                                                        width: '100%',
                                                        opacity: dragStart ? 0.6 : 1
                                                    }}
                                                    justify='center'
                                                    align={'center'}
                                                    onClick={()=> this.addTile()}>
                                                        {loader ?
                                                        <Group justify='center' align={'center'}>
                                                            <Loader/>
                                                        </Group>
                                                        :
                                                        <span style={{
                                                            fontSize: '16px',
                                                            fontWeight: 400,
                                                            color: '#727293'
                                                        }}>Hinzufügen</span>}
                                                    </Group>}
                                                </SimpleGrid>
                                                {provided.placeholder}
                                            </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </Group>}
                            </Stack>
                        </div>
                    </Accordion.Panel>
                </Accordion.Item>
            </Accordion>


                {openTenantPortalTilePreviewModal &&
                <TenantPortalTilePreviewModal
                open={openTenantPortalTilePreviewModal}
                className={'expandImageModal'}
                toggle={()=> this.setState({openTenantPortalTilePreviewModal: false, tileDataForPreview: null, openTileDetailModal: false})}
                modalContent={
                <Stack className='dashboard-general-card' onClick={()=> this.setState({openTileDetailModal: true})} style={{minWidth: '360px', cursor: 'pointer'}} gap={'lg'}>
                    {<>
                        <Group justify="space-between">
                            <Group wrap="nowrap" align='flex-end'>
                                <span className='dashboard-general-card-heading'>{'Aushang'}</span>
                            </Group>
                        </Group>
                        {true ?
                        <Stack style={{overflowY: 'hidden'}}>
                            {tileDataForPreview?.title && <span className='tile-preview-title'>{tileDataForPreview?.title}</span>}
                            <div className='tile-preview-body' dangerouslySetInnerHTML={{__html: tileDataForPreview?.body}}/>
                        </Stack>
                        :
                        <Stack align={'center'} justify={'center'} style={{height: '100%'}} className='empty-state-container-dashboard'>
                            {/* <EmptyState
                            icon={messagesIcon}
                            title='Es sind noch keine Nachrichten vorhanden.'
                            subText='Nachrichten, die Ihr Vermieter versendet, werden Ihnen hier angezeigt.'
                            subTextClassName='empty-state-subtext-dashboard'
                            /> */}
                        </Stack>
                        }
                    </>}
                    <Group justify='right'>
                        <Group className='dashboard-general-card-all' onClick={()=> this.setState({openTileDetailModal: true})} align={'flex-end'}>
                            <span style={{cursor: 'pointer'}}>Mehr anzeigen</span>
                        </Group>
                    </Group>
                </Stack> 
                }
                />}
                {openTileDetailModal &&
                <TileDetailsModal
                open={openTileDetailModal}
                toggle={()=> this.setState({openTenantPortalTilePreviewModal: true, openTileDetailModal: false})}
                tile={tileDataForPreview}
                />}
                {openDeleteModal &&
                <DeleteModal
                open={openDeleteModal}
                className="delete-rent-modal"
                toggle={()=> this.setState({openDeleteModal: false, deleteTileId: null})}
                record={null}
                handleDelete={() => this.deleteTile(deleteTileId)}
                // showInfo={[this.props.propertyData.name,]}
                rightButtonText={'Löschen'}
                leftButtonText={'Abbrechen'}
                type={lang.property.text_property}
                showtext={false}
                showDeleteText={false}
                textShowModal={'Aushang löschen'}
                typeText={'Sind Sie sicher, dass Sie den Aushang löschen wollen? Alle Inhalte gehen unwiderruflich verloren.'}
                modalId="delete-notes"
                />}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property
  };
};
export default connect(mapStateToProps)(TenantAdministrateTilesSection);
